'use client';

import { DataToolsView } from '@slims/ui/organisms';
import { ConfigSwitcher } from '@/components/onboarding/config-switcher';
import { DemoMeterData } from '@/components/reports/demo-meter-data';
import { GseMockExport } from '@/components/reports/gse-mock-export';
import { GseXlsxCards } from '@/components/reports/gse-xlsx-cards';
import { MockBollette } from '@/components/reports/mock-bollette';

/** Platform data tools, protected by the superadmin route guard. */
export default function DatiPage() {
	return (
		<DataToolsView
			scopeSelector={<ConfigSwitcher />}
			demoData={<DemoMeterData />}
			additionalTools={
				<>
					<GseMockExport />
					<GseXlsxCards />
					<MockBollette />
				</>
			}
		/>
	);
}
